<template>
  <div>
    <!-- Section 1: Mempelai -->
    <div id="section1" class="page-section1" :style="{ backgroundImage: `url('/img/bg_section1 copy.jpeg')` }">
      <video ref="s1Video" class="s1-bg-video" src="/img/video_section1.mp4" muted autoplay playsinline webkit-playsinline></video>
      <div class="s1-content hidden-initially" :class="{ 'show-animated': s1ContentVisible }">
        <div class="photo-frame-oval s1-photo">
          <img :src="couplePhotoUrl" alt="Foto Pasangan" loading="lazy" @error="$event.target.src='/img/cover1.jpeg'">
        </div>
        <div class="s1-text-glass">
          <p class="s1-sub">THE WEDDING OF</p>
          <h2 class="s1-name">{{ client.nama_pria || 'Pria' }} &amp; {{ client.nama_wanita || 'Wanita' }}</h2>
          <p class="s1-date">{{ weddingDateShort }}</p>
        </div>
        <div class="s1-scroll-wrapper">
          <div class="scroll-bounce">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#1C2D4A"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          </div>
        </div>
      </div>
    </div>

    <!-- Section 2: Surah (dynamic from response) -->
    <div id="section2" class="page-section2">
      <img src="/img/Wayang-logo.png" alt="Gunungan" loading="lazy" class="s2-icon fade-on-scroll">
      <div class="s2-quote fade-on-scroll" v-html="client.quote"></div>
      <p class="s2-source fade-on-scroll">{{ client.title_quote }}</p>
    </div>

    <!-- Section 3: Detail Mempelai -->
    <div id="section3" class="page-section3">
      <div class="s3-intro fade-on-scroll">
        <strong>Assalamualaikum Wr. Wb.</strong>
        Dengan memohon Rahmat &amp; Ridho Allah SWT, kami bermaksud mengundang Bapak/Ibu/Saudara/i untuk
        menghadiri acara pernikahan putra-putri kami:
      </div>

      <div class="profile-block fade-on-scroll" :style="{ order: client.hajat === 'wanita' ? 2 : 1 }">
        <img :src="groomPhotoUrl" alt="Groom" loading="lazy" class="profile-photo" @error="$event.target.src='/img/cover1.jpeg'">
        <h3 class="profile-name">{{ client.nama_pria_lengkap || client.nama_pria }}</h3>
        <p class="profile-parents">
          <strong>Putra dari</strong><br>
          {{ client.nama_ayah_pria || 'Bapak ...' }}<br>
          &amp;<br>
          {{ client.nama_ibu_pria || 'Ibu ...' }}
        </p>
        <a v-if="client.ig_pria" :href="`https://instagram.com/${client.ig_pria}`"
          target="_blank" rel="noopener" class="btn-ig">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
            <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
            <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
          </svg>
          @{{ client.ig_pria }}
        </a>
      </div>

      <div class="profile-block fade-on-scroll" :style="{ order: client.hajat === 'wanita' ? 1 : 2 }">
        <img :src="bridePhotoUrl" alt="Bride" loading="lazy" class="profile-photo" @error="$event.target.src='/img/cover1.jpeg'">
        <h3 class="profile-name">{{ client.nama_wanita_lengkap || client.nama_wanita }}</h3>
        <p class="profile-parents">
          <strong>Putri dari</strong><br>
          {{ client.nama_ayah_wanita || 'Bapak ...' }}<br>
          &amp;<br>
          {{ client.nama_ibu_wanita || 'Ibu ...' }}
        </p>
        <a v-if="client.ig_wanita" :href="`https://instagram.com/${client.ig_wanita}`"
          target="_blank" rel="noopener" class="btn-ig">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
            <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
            <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
          </svg>
          @{{ client.ig_wanita }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia';
import { useInvitationStore } from '@/store';
import moment from 'moment';

export default {
  name: 'BrideGroomSection',
  props: {
    isInvitationOpen: { type: Boolean, default: false },
  },
  data() {
    return {
      s1ContentVisible: false,
      s1VideoTimer: null,
    };
  },
  computed: {
    ...mapState(useInvitationStore, ['client', 'config']),
    couplePhotoUrl() {
      const foto = this.client.foto_couple || this.client.foto_cover;
      return foto
        ? `https://admin.itsyourdayofficial.com/foto_cover/${foto}`
        : 'https://images.unsplash.com/photo-1511285560929-80b456fea0bc?auto=format&fit=crop&w=400&q=80';
    },
    groomPhotoUrl() {
      return this.client.foto_pria
        ? `https://admin.itsyourdayofficial.com/foto_calon/${this.client.foto_pria}`
        : 'https://images.unsplash.com/photo-1600486913747-55e5470d6f40?auto=format&fit=crop&w=400&q=80';
    },
    bridePhotoUrl() {
      return this.client.foto_wanita
        ? `https://admin.itsyourdayofficial.com/foto_calon/${this.client.foto_wanita}`
        : 'https://images.unsplash.com/photo-1546961448-6d2745a557cd?auto=format&fit=crop&w=400&q=80';
    },
    weddingDateShort() {
      const d = this.client.tgl_resepsi || this.client.tgl_akad;
      return d ? moment(d).format('DD . MM . YYYY') : '';
    },
  },
  mounted() {
    this.setupFadeObserver();
  },
  beforeUnmount() {
    if (this.s1VideoTimer) clearTimeout(this.s1VideoTimer);
    const video = this.$refs.s1Video;
    if (video) {
      video.removeEventListener('timeupdate', this._onTimeUpdate);
      video.removeEventListener('ended', this._onVideoEnded);
    }
  },
  methods: {
    startVideo() {
      const video = this.$refs.s1Video;
      if (!video) {
        // No video element — show content immediately
        this.s1ContentVisible = true;
        return;
      }

      let contentShown = false;

      this._onTimeUpdate = () => {
        if (video.currentTime >= 8 && !contentShown) {
          contentShown = true;
          this.s1ContentVisible = true;
        }
      };

      this._onVideoEnded = () => {
        video.classList.add('fade-out');
        if (!contentShown) {
          contentShown = true;
          this.s1ContentVisible = true;
        }
      };

      video.addEventListener('timeupdate', this._onTimeUpdate);
      video.addEventListener('ended', this._onVideoEnded);

      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(() => {
          // Autoplay blocked — show content after 1s fallback
          this.s1VideoTimer = setTimeout(() => {
            if (!contentShown) {
              contentShown = true;
              this.s1ContentVisible = true;
            }
          }, 1000);
        });
      }

      // Hard fallback: if video has no src or stalls, show content after 9s
      this.s1VideoTimer = setTimeout(() => {
        if (!contentShown) {
          contentShown = true;
          this.s1ContentVisible = true;
        }
      }, 9000);
    },
    setupFadeObserver() {
      if (typeof IntersectionObserver === 'undefined') return;
      const observer = new IntersectionObserver(
        (entries) => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('is-visible'); }),
        { threshold: 0.15 }
      );
      this.$el.querySelectorAll('.fade-on-scroll').forEach(el => observer.observe(el));
      this._fadeObserver = observer;
    },
  },
};
</script>

<style scoped>
.fade-on-scroll { opacity: 0; transform: translateY(40px); transition: opacity 1s ease-out, transform 1s ease-out; }
.fade-on-scroll.is-visible { opacity: 1; transform: translateY(0); }

/* Section 1 */
.page-section1 {
  min-height: 100vh; width: 100%; display: flex; flex-direction: column;
  align-items: center; justify-content: center; position: relative; overflow: hidden;
  background-color: #1C2D4A;
  background-size: cover;
  background-position: center;
}
.s1-bg-video {
  position: absolute; top: 0; left: 0; width: 100%; height: 100%;
  object-fit: cover; z-index: 1; transition: opacity 1.5s ease;
}
.s1-bg-video.fade-out { opacity: 0; }
.s1-content {
  position: relative; display: flex; flex-direction: column; align-items: center;
  text-align: center; width: 90%; max-width: 280px; z-index: 2;
  padding-top: calc(200px + 1.5rem); margin-top: 8vh;
}
.hidden-initially .s1-photo {
  opacity: 0; transform: translate(-50%, 20px); pointer-events: none;
  transition: opacity 1.5s ease, transform 1.5s ease;
}
.hidden-initially .s1-text-glass {
  opacity: 0; transform: translateY(20px); pointer-events: none;
  transition: opacity 1.5s ease, transform 1.5s ease;
}
.hidden-initially .s1-scroll-wrapper { opacity: 0; transition: opacity 1.5s ease; }
.show-animated .s1-photo { opacity: 1; transform: translate(-50%, 0); pointer-events: auto; }
.show-animated .s1-text-glass { opacity: 1; transform: translateY(0); pointer-events: auto; transition-delay: 0.8s; }
.show-animated .s1-scroll-wrapper { opacity: 1; transition-delay: 2.2s; }
.s1-photo {
  position: absolute; top: -11vh; left: 50%; transform: translateX(-50%);
  width: 200px; height: 300px; border-radius: 110px; overflow: hidden;
  border: 2px solid rgba(74,92,116,0.35); box-shadow: 0 8px 24px rgba(0,0,0,0.15);
}
.s1-photo img { width: 100%; height: 100%; object-fit: cover; }
.s1-text-glass {
  background: rgba(255,255,255,0.4); backdrop-filter: blur(3px); -webkit-backdrop-filter: blur(3px);
  border-radius: 12px; display: flex; flex-direction: column; align-items: center; width: auto;
  box-shadow: 0 4px 15px rgba(0,0,0,0.05);
}
.s1-sub { font-family: 'Cinzel', serif; font-size: 0.8rem; letter-spacing: 3px; color: #1C2D4A; margin-bottom: 0.2rem; font-weight: 600; }
.s1-name { font-family: 'Great Vibes', cursive; color: #1C2D4A; font-size: 3.2rem; font-weight: 400; margin-bottom: 0.4rem; line-height: 1.2; white-space: nowrap; }
.s1-date { font-family: 'Cinzel', serif; font-size: 0.9rem; letter-spacing: 4px; font-weight: 500; color: #1C2D4A; }
.s1-scroll-wrapper { margin-top: 2rem; }
.scroll-bounce { animation: bounce 2s infinite; }
@keyframes bounce {
  0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
  40% { transform: translateY(-12px); }
  60% { transform: translateY(-6px); }
}

/* Section 2 */
.page-section2 {
  min-height: 100vh; width: 100%; display: flex; flex-direction: column; align-items: center;
  justify-content: center; background: linear-gradient(rgba(74,92,116,0.9), rgba(74,92,116,0.9)), url('~@/assets/images/cover1.jpeg') center/cover;
  padding: 3rem 2rem; text-align: center; color: #ffffff;
}
.s2-icon { width: 100px; margin-bottom: 2rem; }
.s2-quote { font-family: 'Cormorant Garamond', serif; font-size: 1.2rem; line-height: 1.6; margin-bottom: 2rem; max-width: 600px; }
.s2-source { font-family: 'Cinzel', serif; font-size: 1rem; font-weight: 500; }

/* Section 3 */
.page-section3 {
  min-height: 100vh; width: 100%; display: flex; flex-direction: column; align-items: center;
  background: linear-gradient(rgba(255,255,255,0.77), rgba(255,255,255,0.77)), url('~@/assets/images/design-jawa-biru.jpg') center/cover;
  padding: 4rem 2rem; text-align: center;
}
.s3-intro {
  font-family: 'Cormorant Garamond', serif; font-size: 1.2rem; line-height: 1.6; color: #1A2841;
  font-style: italic; margin-bottom: 3.5rem; max-width: 600px; font-weight: 500;
}
.s3-intro strong {
  font-family: 'Cinzel', serif; font-weight: 700; font-style: normal; display: block;
  margin-bottom: 0.8rem; font-size: 1.3rem; text-transform: uppercase; letter-spacing: 1px;
}
.profile-block { margin-bottom: 4rem; display: flex; flex-direction: column; align-items: center; }
.profile-photo {
  width: 200px; height: 280px; border-radius: 120px; object-fit: cover;
  margin-bottom: 1.5rem; box-shadow: 0 15px 35px rgba(0,0,0,0.15); border: 3px solid rgba(255,255,255,0.5);
}
.profile-name { font-family: 'Great Vibes', cursive; font-size: 3.5rem; color: #0F1A2C; margin-bottom: 1rem; text-shadow: 0 0 10px rgba(255,255,255,1), 0 0 20px rgba(255,255,255,0.8); }
.profile-parents { font-family: 'Cinzel', serif; font-size: 1rem; color: #1A2841; line-height: 1.8; margin-bottom: 1.5rem; text-transform: uppercase; font-weight: 500; }
.profile-parents strong { font-weight: 700; font-size: 1.1rem; color: #0F1A2C; letter-spacing: 1px; margin-bottom: 0.3rem; display: inline-block; }
.btn-ig {
  background-color: #5A708A; color: white; font-family: 'Cinzel', serif; font-size: 0.8rem;
  padding: 0.8rem 1.8rem; border-radius: 30px; text-decoration: none; display: inline-flex;
  align-items: center; gap: 8px; transition: background 0.3s, transform 0.3s; letter-spacing: 1.5px; text-transform: uppercase;
}
.btn-ig:hover { background-color: #3C4E63; transform: translateY(-2px); }
</style>
